angular.module('shared').factory('SessionCheckerService', [
  '$q',
  '$stateParams',
  '$http',
  function($q,
  $stateParams,
  $http) {
    var loadDebounced,
  serviceRunning;
    serviceRunning = true;
    loadDebounced = _.debounce(function(deferred) {
      var gymId;
      if (serviceRunning) {
        gymId = $stateParams.gymId;
        return $http.get(`/gyms/${gymId}/session_status`).then(function(response) {
          return deferred.resolve(response != null ? response.data : void 0);
        },
  function(error) {
          if (error.data.login_status === 'signed_out' || error.data.login_status === 'timed_out') {
            return deferred.resolve({
              error: true
            });
          }
        });
      }
    },
  500);
    return {
      load: function() {
        var deferred;
        deferred = $q.defer();
        loadDebounced(deferred);
        return deferred.promise;
      },
      stopService: function() {
        return serviceRunning = false;
      }
    };
  }
]);

angular.module('shared').directive('sessionChecker', function() {
  return {
    restrict: 'E',
    controller: [
      '$scope',
      'SessionCheckerService',
      'ReactModal',
      function($scope,
      SessionCheckerService,
      ReactModal) {
        var checkSession;
        checkSession = function() {
          return SessionCheckerService.load().then(function(sessionChecks) {
            if (sessionChecks != null ? sessionChecks.error : void 0) {
              $scope.openModal();
              return SessionCheckerService.stopService();
            }
          });
        };
        $scope.openModal = function() {
          return ReactModal.open({
            component: 'SessionTimedOutModal'
          });
        };
        return window.setInterval(checkSession,
      60000);
      }
    ]
  };
});
